export default __webpack_public_path__ + "static/media/undraw_notify_rnwe 1.10120c61.svg";